export default "__VITE_ASSET__pPh6VS5W__"